import {action} from 'mobx';
import s from '../s';
import {MatCustomization} from '../i';
import {prod_entity_zoom_destroy} from '../../util';
import {scrollToPreview} from './preview-scroll';

// The mat selection, shared by both product page layouts. Moved unchanged from components/mat/mat.tsx (the handlers) and
// components/mat/components/mat-list.tsx (the tile order).

export const selectMat = action((id: number): void => {
    prod_entity_zoom_destroy();
    if (!s.ps.is_caf) {
        s.ui.update_pricing = true;
        s.ps.matcombo_id = id;
        const m = s.prod.mats.filter(x => x.id === id)[0];
        s.ps.mat1_id = m.mat1_id;
        s.ps.mat2_id = m.mat2_id;
        s.ps.mat1_color = m.pmat_color;
        s.ps.mat2_color = m.smat_color;
        s.ps.ins_gold_allowed = m.ins_gold_allowed;
        s.ps.ins_silver_allowed = m.ins_silver_allowed;
        s.ps.ins_black_allowed = m.ins_black_allowed;
        s.ui.doRender = true;

        if (m) {
            s.ui.linen = m.pmat_name.toLowerCase().includes('linen');
        }

        if (s.prod.CustomizationMethod === 1 && m.ImageName) {
            s.ui.old_style_composite = m.ImageName.toLowerCase();
        }

        s.pulse();
    } else {
        s.ui.update_pricing = true;
        const m1 = s.prod.caf_mat1.filter(x => x.id === id)[0];
        const m2 = s.prod.caf_mat2.filter(x => x.id === id)[0];
        if (m1) {
            s.ps.mat1_id = m1.id;
            s.ps.mat1_color = m1.mat_color;
            s.ps.ins_gold_allowed = m1.ins_gold_allowed;
            s.ps.ins_silver_allowed = m1.ins_silver_allowed;
            s.ps.ins_black_allowed = m1.ins_black_allowed;

            if (m1) {
                s.ui.linen = m1.name.toLowerCase().includes('linen');
            }
        } else if (m2) {
            s.ps.mat2_id = m2.id;
            s.ps.mat2_color = m2.mat_color;
        }

        if (id === -1) {
            s.ps.mat2_id = -1;
            s.ps.mat2_color = '';
            s.ui.name_mat2 = 'No Inner Accent';
            s.ui.color_mat2 = '';
            s.ui.title_mat2 = 'No Inner Accent';
        }

        s.ui.doRender = true;
        s.pulse();
    }

    scrollToPreview('prod-header');
});

/** A CAF Varsity background (frame style 4). */
export const selectMatBackground = action((id: number): void => {
    const m2 = s.prod.caf_mat2.filter(x => x.id === id)[0];
    if (m2) {
        s.ps.vlbg_id = id;
        s.ps.vlbg_color = m2.mat_color;
        s.ui.title_vlbg = m2.title;
        s.ui.doRender = true;
        s.pulse();

        scrollToPreview('prod-header');
    }
});

// ---- view model ------------------------------------------------------------------------------------------------------

/** Mat's own rule for a catalogue (non-CAF) product: more than one mat combination. */
export const matSectionShown = (): boolean => s.ready && s.ui.show_cust && !s.ps.is_caf && !!s.prod.mats && s.prod.mats.length > 1;

/** The mat tiles in their order (MatList), the first count of them. */
export const matTiles = (count: number): MatCustomization[] => (s.pcs.IsCAF ? [...s.prod.mats].sort((a, b) => a.SortOrder - b.SortOrder).slice(0, count) : s.prod.mats.slice(0, count));

/** The Fast Ship icon on a mat tile: the product's own mat combination on a Fast Ship product. */
export const isFastShipMat = (m: MatCustomization): boolean => s.__fast_ship_orig && s.isRetail && s.prod.MatComboID === m.id;
